
const Logger = {
  log: (level: any, message: string, extra: any) => {
    console.log(`${level}: ${message}`, extra);
  },

  logError: (error: Error, extra?: any) : Promise<string> => {
    console.error(error, extra);
    return Promise.resolve('');
  }
}

export default Logger;